import {useState, useEffect} from "react"
import { Link } from 'react-router';
import {Modal,Button,Row} from 'react-bootstrap'
import './Sign.css'
import SignEmail from "./SignEmail"
import SignPhone from "./SignPhone"
import SignApi from './SignApi'
import {ToNotify} from 'fast_inon'
import {Ts} from '../Config/switcher';

const signApi = new SignApi()

const SignModal = ({lang, app, show, logo, onHide}) => {
  const [message, Message] = useState('')
  const [activeTab, setActiveTab] = useState("Email")
  const [code, setCode] = useState('')

  const T = (value, key='header') => Ts(lang, key, value)

    const onEmail = () => {
        setActiveTab("Email")
    }

    const onPhone = () => {
      setActiveTab("Phone")
    }

    useEffect(() => {
      setCode(signApi.message)
      if(signApi.data.mode===3) {
        window.location.reload()
      } 
    }, [signApi.data.mode])

    const onClose = () => {
      onHide()
      if(signApi.data.mode===3) {
        window.location.reload()
      }      
    }


  return (
    <div className="mt-5 d-flex justify-content-left">

    <Modal show={show}
            onHide={onClose}
                size="lg"
                animation={false}
                centered
            >
          
        <Modal.Header closeButton>
            <Row  style={{ justifyContent:"center", width:"100%"}}>
                <h3 style={{color:"darkblue", margin:"0rem"}}>Sign In {app} </h3>
            </Row>          
        </Modal.Header>

        <Modal.Body>
          <Row style={{ justifyContent:"center", width:"100%"}}>
              <img  src={logo} alt="Home" style={{width:'9rem', aspectRatio:'1/1', padding:0}} />
          </Row>
  
    <div className="Tabs">
      { signApi.data.mode===1 ?
      <ul className="nav">
        <li className={activeTab === "Email" ? "active" : ""} onClick={onEmail}>Email</li>
        <li className={activeTab === "Phone" ? "active" : ""} onClick={onPhone}>Phone</li>
      </ul>
      : 
      <h3 style={{color:"lightblue", margin:"2rem"}}>{code}</h3> 
      }
      
      { activeTab === "Email" ? <SignEmail signApi={signApi} onMessage={Message}/> 
                              : <SignPhone signApi={signApi} onMessage={Message}/> }
    </div>

    <Link className="d-inline p-3" to="/signup" ><i className="fa fa-edit">{T('signup')}</i></Link>  
    </Modal.Body>

    <Modal.Footer>
      <Button variant="outline-danger" onClick={onClose}><i className="fa fa-close"></i> Close</Button>
    </Modal.Footer>
  </Modal>
 
    <ToNotify 
      message={message}
      onClose={()=>{Message('')}}
    />    

    </div>

  )
}
export default SignModal